document.addEventListener("DOMContentLoaded", () => {
  const preArticleInfo = document.getElementById("button-toggle-pre-article-info");
  if (!preArticleInfo) return;

  preArticleInfo.addEventListener("click", (e) => {
    e.preventDefault();

    const preArticleInfoContent = preArticleInfo.nextElementSibling;
    if (!preArticleInfoContent) return;

    preArticleInfoContent.classList.toggle("show");
  });
});